<div class="td-wb-unsigned-agreements__header-container">
  <div class="td-wb-unsigned-agreements__header-icon">
    <td-wb-icon iconId="logo--td"
                size="29x26">
    </td-wb-icon>
  </div>
</div>
<td-wb-modal-panel [right]="false"
                   [left]="false"
                   class="td-wb-unsigned-agreements__container">
  @if (loading) {
    <td-wb-loading-indicator position="center"></td-wb-loading-indicator>
  } @else if (unsignedAgreements?.length > 0) {
    <div class="td-wb-unsigned-agreements__inner-container">
      <div class="td-wb-unsigned-agreements__title-icon">
        <img alt=""
             src="assets/core/illustrations/agreements--not-signed.svg"
             width="150"
             height="73.43"/>
      </div>
      <h1 class="td-wb-unsigned-agreements__title" translate="tdWb.platform.unsignedAgreements.TITLE"></h1>
      <div class="td-wb-unsigned-agreements__description">
        <p translate="tdWb.platform.unsignedAgreements.DESCRIPTION_1"></p>
        <p translate="tdWb.platform.unsignedAgreements.DESCRIPTION_2"></p>
        <p translate="tdWb.platform.unsignedAgreements.DESCRIPTION_3"></p>
      </div>
      <td-wb-consolidated-agreements-list [agreements]="unsignedAgreements"
                                          hideHeaders></td-wb-consolidated-agreements-list>
      <div>
        <span class="td-wb-unsigned-agreements__text"
              translate="tdWb.platform.unsignedAgreements.REVIEW_ANYTIME_1"></span>
        <span class="td-wb-unsigned-agreements__text--bold"
              translate="tdWb.platform.unsignedAgreements.REVIEW_ANYTIME_2"></span>
      </div>
      <div class="td-wb-unsigned-agreements__footer">
        <button id="td-wb-unsigned-agreements-accept-button"
                class="td-wb-unsigned-agreements__button"
                tdWbButton
                tdWbButtonType="primary"
                tdWbBlock="spinningAndBlock"
                [disabled]="isBlocked"
                (click)="submitAgreements()">
          <span translate="tdWb.platform.unsignedAgreements.ACCEPT_ALL_AGREEMENTS"></span>
        </button>
      </div>
    </div>
  }
</td-wb-modal-panel>
